import axios from "axios";

const ChatService = () => {
  const defaultOptions = {
    baseURL: process.env.REACT_APP_CHAT_AI_ENDPOINT + "/api/v1/chat",
    headers: {
      "Content-Type": "application/json",
      "X-XSS-Protection": "X-XSS-Protection: 1; mode=block",
      "X-Frame-Options": "SAMEORIGIN",
      "Strict-Transport-Security": "max-age=10000000",
      "Content-Security-Policy": "default-src 'self'; child-src 'none';",
      "Referrer-Policy": "no-referrer",
      "X-Content-Type-Options": "nosniff",
      Authorization: "Bearer " + localStorage.getItem("localAuthorization"),
    },
  };

  let instance = axios.create(defaultOptions);

  return instance;
};

export default ChatService();

const fetchChatbotAnswer = async (payload) => {
  const res = await ChatService().post(`/ask`, payload);
  if (res.status === 200) {
    return res.data;
  }
};

const createNewChatSession = async (payload) => {
  const res = await ChatService().post(`/history`, payload);
  if (res.status === 200) {
    return res.data;
  }
};

const getAllChatSessions = async () => {
  const res = await ChatService().get(`/history`);
  if (res.status === 200) {
    return res.data;
  }
};

const getChatSessionByUUID = async (session_uuid) => {
  const res = await ChatService().get(`/history/${session_uuid}/messages`);
  if (res.status === 200) {
    return res.data;
  }
};

const storeChatSessionFeedback = async (session_uuid, payload) => {
  const res = await ChatService().post(
    `/history/${session_uuid}/feedback`,
    payload
  );
  if (res.status === 200) {
    return res.data;
  }
};

/* 
ATTENZIONE: QUESTA FUNZIONALITà è STATA IMPLEMENTATA SOLO PER DGS
PER IL PROGETTO GRIDESPERTISE DA UTILIZZARE QUANDO GLI UTENTI NON SELEZIONANO ALCUN CHATBOT
*/
const fetchChatbotAnswerDGSBedrock = async (payload) => {
  const res = await ChatService().post(`/dgs/ai`, payload);
  if (res.status === 200) {
    return res.data;
  }
};

/* 
ATTENZIONE: QUESTA FUNZIONALITà è STATA IMPLEMENTATA SOLO PER DGS
PER IL PROGETTO GRIDESPERTISE DA UTILIZZARE QUANDO GLI UTENTI SELEZIONANO IL CHATBOT AGENTE
*/
const fetchDGSAgentAnswer = async (payload) => {
  const res = await ChatService().post(`/dgs/agent`, payload);
  if (res.status === 200) {
    return res.data;
  }
};

export {
  fetchChatbotAnswer,
  fetchChatbotAnswerDGSBedrock,
  fetchDGSAgentAnswer,
  createNewChatSession,
  getAllChatSessions,
  getChatSessionByUUID,
  storeChatSessionFeedback,
};
